import api from './api';

export interface CourseOverview {
  totalExperiments: number;
  experimentsCompleted: number;
  completionPercentage: number;
  averageQuizScore: number | null;
  totalActivities: number;
  feedbackCount: number;
}

export interface ExperimentDetail {
  experimentId: number;
  experimentNumber: number;
  experimentName: string;
  status: string;
  stepsCompleted: number;
  totalSteps: number;
  partsCompleted: string[];
  quizScore: number | null;
  bestQuizScore: number | null;
  hasFeedback: boolean;
  lastActivity: string | null;
}

export interface ActivityEntry {
  id: number;
  activityType: string;
  description: string;
  experimentNumber: number | null;
  experimentName: string | null;
  createdAt: string;
}

export const studentProgressService = {
  async getCourseOverview(courseId: string): Promise<CourseOverview | null> {
    const res = await api.get<{ success: boolean } & CourseOverview>(
      `/student-progress/${courseId}/overview`
    );
    return res.success && res.data ? res.data : null;
  },

  async getExperimentDetails(courseId: string): Promise<ExperimentDetail[]> {
    const res = await api.get<{ success: boolean; experiments: ExperimentDetail[] }>(
      `/student-progress/${courseId}/experiments`
    );
    return res.success && res.data ? res.data.experiments : [];
  },

  async getTimeline(
    courseId: string,
    page = 1
  ): Promise<{ activities: ActivityEntry[]; total: number }> {
    const res = await api.get<{
      success: boolean;
      activities: ActivityEntry[];
      total: number;
    }>(`/student-progress/${courseId}/timeline?page=${page}&limit=20`);
    return res.success && res.data
      ? { activities: res.data.activities, total: res.data.total }
      : { activities: [], total: 0 };
  },

  async getQuizSummary(courseId: string) {
    const res = await api.get<{ success: boolean; scores: any[] }>(
      `/student-progress/${courseId}/quiz-summary`
    );
    return res.success && res.data ? res.data.scores : [];
  },
};
